/**
 * 根据容器的宽度进行高度适应
 * @param {Object} ref dom元素对象 
 * @param {Number} width 
 * @param {Number} height 
 */
export const resizeCalc = (ref, width, height) => {
    const radio = ref.offsetWidth / width;
    return `${height * radio}px`;
}
/*
 *定位页面目标元素到可视区域的减速滑动
 *作用类似却优于a标签锚点
 *@param targetPageY 目标元素位置(pageY)
 */
export function slideTo(targetPageY, toTop = false) {
    var currentY = document.documentElement.scrollTop || document.body.scrollTop; //当前及滑动中任意时刻位置
    var timer = setInterval(function () {
        var distance = targetPageY > currentY ? targetPageY - currentY : currentY - targetPageY; //剩余距离
        var speed = Math.ceil(distance / 10); //每时刻速度
        if (toTop) {
            clearInterval(timer);
            window.scrollTo(0, 0);
            return;
        }
        if (currentY >= targetPageY) {
            clearInterval(timer);
        } else {
            currentY = targetPageY > currentY ? currentY + speed : currentY - speed
            window.scrollTo(0, currentY);
        }
    }, 10);
}
export function assignKeys(target = {}, source, keys) {
    if (source != undefined) {
        let key, value;
        for (let i = 0; i < keys.length; i++) {
            key = keys[i];
            value = source[key];
            if (value !== undefined) {
                target[key] = value;
            }
        }
    }
    return target;
}
/**
 * 合并对象
 * @param {Object} target  目标
 * @param {Array} sources  对象
 * @param {Array} keys     字段
 */
export function assignKeysA(target, sources, keys) {
    for (let i = 0; i < sources.length; i++) {
        assignKeys(target, sources[i], keys);
    }
    return target;
}

export function delKeys(target, keys) {
    for (let i = 0; i < keys.length; i++) {
        delete target[keys[i]];
    }
}